
import React from 'react';
import PatientHeader from '@/ui/shared-components/patient/Header';
import PatientBottomNav from '@/ui/shared-components/patient/BottomNav';
import { cn } from '@/lib/utils';
import { Outlet } from 'react-router-dom';

interface PatientPageLayoutProps {
  children?: React.ReactNode;
  title?: string;
  showBackButton?: boolean;
  className?: string;
  containerClassName?: string;
  icon?: React.ReactNode;
}

const PatientPageLayout: React.FC<PatientPageLayoutProps> = ({
  children,
  title,
  showBackButton = true,
  className,
  containerClassName,
  icon
}) => {
  return (
    <div className={cn("min-h-screen bg-muted/30 pb-20 pt-16", className)}>
      <PatientHeader title={title} showBackButton={showBackButton} icon={icon} />
      
      <div className={cn("container mx-auto px-4 pt-6 pb-16", containerClassName)}>
        {children || <Outlet />}
      </div>
      
      <PatientBottomNav />
    </div>
  );
};

export default PatientPageLayout;
